import { Injectable } from '@angular/core';
import {
  UrlTree, CanLoad, Route, UrlSegment, Router,
} from '@angular/router';
import { PermissionService } from 'projects/cross-study-portal-lib/src/lib/services/permission.service';
import { Observable } from 'rxjs';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';
import {
  ROUTE_ROLES,
  ROUTE_SITES,
  ROUTE_USERS,
  ROUTE_GLOBAL_USERS,
} from '../../route.constants';

@Injectable({
  providedIn: 'root',
})
export class ModulePermissionGuard implements CanLoad {
  constructor(private permissionService: PermissionService, private router: Router, private context: ContextService) {
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    let stopLoading = false;
    if (segments.length > 0) {
      switch (segments[0].path) {
        case ROUTE_ROLES:
          stopLoading = (this.context.instance.isApiUser) || !this.permissionService.canManageRoles();
          break;
        case ROUTE_USERS:
          stopLoading = (this.context.instance.isApiUser) || !this.permissionService.canManageUsers();
          break;
        case ROUTE_GLOBAL_USERS:
          stopLoading = (this.context.instance.isApiUser) || !this.permissionService.canManageUsers();
          break;
        case ROUTE_SITES:
          stopLoading = (this.context.instance.isApiUser) ||
                        (!this.permissionService.canReadSites() && !this.permissionService.canEditSites());
          break;
        default:
          break;
      }
    }
    if (stopLoading) {
      this.router.navigateByUrl('');
    }
    return !stopLoading;
  }
}
